import * as React from 'react';

import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { Res } from 'core/api';
import { Flex, Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type State = { reason: string };

class ManualCancellationReason extends PosScreenClassComponent<any, State> {

	private form = React.createRef<UI.Form<State>>();

	protected getScreenId(): string {
		return 'MANUAL_CANCELLATION_REASON';
	}

	protected getTitle(): string {
		return Res.Web.GET_LINE_CANCELLATION_REASON();
	}

	protected getImage(): string | SvgIcon {
		return Images.CancelTicketLine;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			{ title: Res.Web.GET_LINE_MANUAL_CANCELLATION_REASON_CLEAR_NOTES_LBL(), image: Images.Clear, action: this.onClear },
			null,
			null,
			this.okButton(this.onOK)
		];
	}

	protected useKeypad() {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	createInitialState(_props: EmptyProps): Nullable<State> {
		return { reason: '' };
	}

	onComponentDidMount(): void { }

	onComponentWillUnmount(): void { }

	private onOK = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.reason);
	};

	private onClear = async () => this.setState({ reason: '' }, () => this.form.current!.remount('reason'));

	protected getContent(): React.ReactNode {
		const { Form, TextBox } = UI.controlsFor<State>();

		return <Flex.Vertical>
			<Flex.Item size='*'>
				<Form ref={this.form} model={this.state}>
					<Cols>
						<Col width='*'>
							<TextBox placeholder={Res.Msg.MSG_ADD_MANUAL_CANCELLATION_REASON_HELP()} linkTo={x => x.reason} lines={10} tabIndex={-1} maxLength={200} required />
						</Col>
					</Cols>
				</Form>
			</Flex.Item>
		</Flex.Vertical>;
	}

}

export default async function getManualCancellationReason(): Promise<Result<string>> {
	return Modal.show(ManualCancellationReason);
}